import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import QuizList from "@student/components/Quizzes/QuizList";
import { useGetVideoQuery } from "@features/videos/videosApi";
import { useGetQuizzesQuery } from "@features/quizzes/quizzesApi";
import { useAddQuizMarkMutation } from "@features/quizMarks/quizMarksApi";
import useGetUserData from "@common/hooks/useGetUserData";

const Quiz = () => {
  const { id } = useParams();

  const { data: video } = useGetVideoQuery(id);

  const { data, isLoading, isError } = useGetQuizzesQuery();

  const quizzes = data?.filter((q) => q.video_id === +id) || [];

  const { selectedOptions } = useSelector((state) => state.quiz);

  const navigate = useNavigate();

  const { id: userId, name } = useGetUserData();

  const [addQuizMark] = useAddQuizMarkMutation();

  const handleQuizSubmit = async () => {
    let finalScore = 0;
    let totalCorrect = 0;
    let totalWrong = 0;
    quizzes?.forEach((question) => {
      let numCorrectOptions = question.options.filter(
        (option) => option.isCorrect
      ).length;
      let numSelectedCorrectOptions = 0;
      let numSelectedIncorrectOptions = 0;
      selectedOptions?.forEach((option) => {
        if (option[question.id]) {
          let selectedAnswer = question.options.find(
            (answer) => answer.id === option[question.id]
          );
          if (selectedAnswer.isCorrect) {
            numSelectedCorrectOptions++;
          } else {
            numSelectedIncorrectOptions++;
          }
        }
      });
      if (
        numSelectedCorrectOptions === numCorrectOptions &&
        numSelectedIncorrectOptions === 0
      ) {
        finalScore += 5;
        totalCorrect += 1;
      } else {
        totalWrong += 1;
      }
    });

    const data = {
      student_id: userId,
      student_name: name,
      video_id: video?.id,
      video_title: video?.title,
      totalQuiz: quizzes?.length,
      totalCorrect,
      totalWrong,
      totalMark: quizzes?.length * 5,
      mark: finalScore,
    };

    const response = await addQuizMark(data);
    if (response?.data) {
      navigate("/leaderboard");
      toast.success("Quiz submitted successfully!");
    } else {
      toast.error("Quiz submitted failed!");
    }
  };

  return (
    <>
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Quizzes for "{video?.title}"</h1>
        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
      </div>

      <QuizList quizzes={quizzes} isLoading={isLoading} isError={isError} />

      <button
        onClick={handleQuizSubmit}
        className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
      >
        Submit
      </button>
    </>
  );
};

export default Quiz;
